<template>
  <div class="sm_link">
    <ul class="list">
      <li v-for="category in categoryIconList" :key="category.title">
        <div
          class="category-icon-wrapper"
          @click="handleCategoryLink(category)"
        >
          <div
            class="icon"
            :style="`background-image: url(${category.img})`"
          ></div>
          <div class="txt" :style="`color: ${category.color}`">
            {{ category.title }}
          </div>
        </div>
      </li>

      <li @click="handleCategoryList" class="category-icon-wrapper">
        <div
          class="icon"
          :style="`background-image: url(${
            isMoreCategory
              ? 'images/links/close.png?v=240119'
              : 'images/links/more.png?v=240119'
          })`"
        ></div>
        <div class="txt">
          {{ isMoreCategory ? $t("S20066") : $t("S20065") }}
        </div>
      </li>

      <li v-for="category in addCategoryIconList" :key="category.title">
        <div
          v-if="isMoreCategory"
          class="category-icon-wrapper"
          @click="handleCategoryLink(category)"
        >
          <div
            class="icon"
            :style="`background-image: url(${category.img})`"
          ></div>
          <div class="txt" :style="`color: ${category.color}`">
            {{ category.title }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
  
  <script>
export default {
  name: "MainQuickMenu",
  data() {
    return {
      isMoreCategory: false,
      categoryIconList: [
        {
          link: "/learn?status=LEARNING&category=60",
          img: "images/links/elearning.png?v=240119",
          title: this.$t("S20043"),
          color: "#505050",
        },
        {
          link: "/learn?status=CONTENTS&category=3",
          img: "images/links/tenTalk.png?v=240119",
          title: this.$t("S20044"),
          color: "#505050",
        },
        {
          link: "/learn?status=CONTENTS&category=71",
          img: "images/links/minTalk.png?v=250404",
          title: this.$t("S20045"),
          color: "#505050",
        },
        {
          link: "/learn?status=CONTENTS&category=1",
          img: "images/links/videoTalk.png?v=240119",
          title: this.$t("S20046"),
          color: "#505050",
        },
      ],
      addCategoryIconList: [
        {
          link: "/learn?status=CONTENTS&category=79",
          img: "images/links/practice.png",
          title: this.$t("S20047"),
          color: "#505050",
        },
        {
          link: "/learn?status=CONTENTS&category=43",
          img: "images/links/sales.png",
          title: this.$t("S20048"),
          color: "#505050",
        },
        {
          link: "/socialLearning?bId=sns",
          img: "images/links/forum.png",
          title: this.$t("S20049"),
          color: "#505050",
        },
        {
          link: "/event",
          img: "images/links/event.png",
          title: this.$t("S20050"),
          color: "#505050",
        },
        {
          link: "/learn?status=LEARNING&category=18",
          img: "images/links/localContent.png",
          title: this.$t("S20051"),
          color: "#505050",
        },
      ],
    };
  },
  methods: {
    handleCategoryList() {
      this.isMoreCategory = !this.isMoreCategory;
    },
    handleCategoryLink(category) {
      if (
        category.title === "Forum" &&
        JSON.parse(localStorage.getItem("noForum"))
      ) {
        return this.$alert({
          content: this.$t("S20083"),
          accept: this.$t("S20084"),
        });
      }

      if (
        category.title === "Event" &&
        JSON.parse(localStorage.getItem("noEvent"))
      ) {
        return this.$alert({
          content: this.$t("S20083"),
          accept: this.$t("S20084"),
        });
      }

      this.$router.push(category.link);
    },
  },
};
</script>
  
  <style scoped>
.sm_link {
  position: relative;
  padding: 20px 0 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.sm_link .list {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-rows: auto;
  max-width: 360px;
  padding: 0;
  list-style: none;
  justify-content: center;
  width: 100%;
}
.sm_link .list li:nth-child(n + 11) {
  display: none;
}
.sm_link .list li {
  width: 100%;
  box-sizing: border-box;
}
.category-icon-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.icon {
  width: 100%;
  aspect-ratio: 1 / 1;
  max-width: 56px;
  background-size: cover;
  background-repeat: no-repeat;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  border-radius: 30%;
}
.txt {
  padding-top: 10px;
  font-size: 11px;
  font-weight: 500;
  color: #667385;
  text-align: center;
}
</style>
  